import { FC } from 'react';

import { useOrderTypeConfiguration } from './hooks';

const OrderType: FC = () => {
  const { component } = useOrderTypeConfiguration();

  return <>{component}</>;
};

export default OrderType;
